// @ts-nocheck
import * as R from 'ramda';
import { isWeb } from 'utils/util';
import { inject } from 'mobx-react';
import intl from 'react-intl-universal';
import React, { ReactNode } from 'react';
import SwipeableViews from 'react-swipeable-views';

import imageUtil from '../../utils/image';
import RootStore from '../../store/RootStore';
import PinchZoomWrapper from './PinchZoomWrapper';
import { BIGPIC_PRELOAD_LENGTH } from './AllForBigPic';

import './BigPic.scss';

interface IBigPicHeader {
  currentImageIndex: number;
  count: number;
  children?: ReactNode;
  tips?: string;
  detail?: any;
  //  迁移的时候, 发现, BigVideoWrapper 中设置了id='', 也就是不显示出来, 所以这儿新增一个属性来保持兼容
  hideOrigin?: boolean;
}

// 055A0118_Jfoto_20240830_1368393570[.jpg] => 055A0118[.jpg]
function processOrigin(name = '') {
  //  .replace(/ Jfoto\d{4}_\d{8}_\d{18}/，"");
  return name
    .replace(/Jfoto_\d{8}_\d+/, '')
    .replace(/Jfoto\d{4}_\d{8}_\d{10}/, '');
}

export const cutFileName = (name) => {
  return (name || "").replace(/_Jfoto(\d{4})?_\d{8}_-?\d{4,}/, "");
};

export const BigPicHeader = (props: IBigPicHeader) => {
  const { currentImageIndex, count, tips } = props;

  const id = R.pathOr('', ['detail', 'id'], props);
  const origin = R.pathOr('', ['detail', 'origin'], props);
  const hideOrigin = R.pathOr(false, ['hideOrigin'], props);
  const showIdIfNoOrigin = hideOrigin ? '' : (cutFileName(origin) || id);



  return (
    <div className="bigpic-head-tip">
      <div
        className="bigpic-head-text"
        style={{ minWidth: '30%', display: 'flex', alignItems: 'center' }}
      >
        {tips ? tips : intl.get('long-press-to-save-1')}
        <span className="image-id origin-id-or-id">{showIdIfNoOrigin}</span>
      </div>
      <div className="bigpic-main-tip">{props.children}</div>
      <div
        style={{
          // width: "30%", //这个宽度导致有弹幕+英文下，显示不完
          marginLeft: 5,
          textAlign: 'right',
        }}
      >
        {currentImageIndex + 1}/{count}
      </div>
    </div>
  );
};

interface IBigPicMain {
  currentImageIndex: number;
  list: any[];
  setCurrentImageIndex: (index: number) => void;
  hideBigPic: () => void;
  onLongPress?: () => void;
  loadFinish?: (index: number, size?: number) => void;
  loadError?: (index: number) => void;
  disablePinchZoom?: boolean;
  rootStore?: RootStore;
  onZoomStart?: (index: number, params: any) => void;
  mode?: string | number;
  currentPayWatermark?: string;
  currentIndexIsPayed?: boolean;
  currentPayGoodId?: string | number;
}

@inject('rootStore')
export default class BigPicMain extends React.Component<IBigPicMain> {
  constructor(props: IBigPicMain) {
    super(props);

    this.state = {
      size: {
        width: window.document.documentElement.clientWidth,
        height: window.document.documentElement.clientHeight,
      } as any,
    };
  }

  onSizeHandler = () => {
    let size = {
      width: window.document.documentElement.clientWidth,
      height: window.document.documentElement.clientHeight,
    };
    this.setState({
      size: size,
    });
  };

  componentDidMount() {
    window.addEventListener('resize', this.onSizeHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onSizeHandler);
  }

  lastSwitchIndex = 0; //上一次滑动时的下标，注意，这个下标其实是个小数
  changeIndex = (index: number, indexLatest: number) => {
    console.log(index, 'index', indexLatest);
    this.props.setCurrentImageIndex(index);
  };
  // 注意，因为最后一张照片右滑不会触发onChangeIndex，只好用这个来判断了
  onSwitching = (index: number, type: string) => {
    if (type === 'move') {
      this.lastSwitchIndex = index;
    } else if (type === 'end') {
      // 移动结束
      if (
        index < this.lastSwitchIndex &&
        index === this.props.list.length - 1
      ) {
        // 已经到底了，最后一张右滑后弹回来了
        this.lastSwitchIndex = index;
        this.props.rootStore!.uiStore.showToast({
          content: intl.get('This is the last one photo'),
        });
      }
    }
  };

  render() {
    const { props } = this;
    const {
      currentImageIndex,
      list,
      mode,
      currentPayWatermark,
      currentIndexIsPayed,
    } = props;

    const { galleryStore } = props.rootStore!;

    let currentImage = list[currentImageIndex];

    let watermarks = [] as any[];
    if (currentImage && currentImage.galleryid) {
      // console.log("这张照片找到了自己的水印");
      watermarks = galleryStore.getWatermarksByKey(
        String(currentImage.galleryid),
        currentImage.show_mark
      );
    } else {
      console.log('为什么这张照片没有相册id', currentImage);
    }

    return (
      <div className={'big-pic-main'}>
        {currentImageIndex !== -1 && list && list.length ? (
          <SwipeableViews
            axis="x"
            enableMouseEvents={true}
            index={currentImageIndex}
            onChangeIndex={this.changeIndex}
            onSwitching={this.onSwitching}
            // 如果不设置成hidden，在大图页会出现右侧的滑动条（0.x秒后消失)
            slideStyle={{ overflow: 'hidden' }}
            resistance={true}
            containerStyle={{
              height: '100%',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {list.map((one, index) => {
              if (
                Math.abs(index - currentImageIndex) <= BIGPIC_PRELOAD_LENGTH
              ) {
                return (
                  <PinchZoomWrapper
                    hideBigPic={props.hideBigPic}
                    onLongPress={props.onLongPress}
                    onZoomStart={props.onZoomStart}
                    // @ts-ignore
                    key={`${this.state.size.width},${this.state.size.height},${index}`}
                    index={index}
                    currentImageIndex={currentImageIndex}
                    data={one}
                    disablePinchZoom={props.disablePinchZoom}
                    //resistance
                    data-index={one.ind}
                    loadFinish={
                      props.loadFinish && props.loadFinish.bind(this, index)
                    }
                    loadError={
                      props.loadError && props.loadError.bind(this, index)
                    }
                    thumb={imageUtil.style(
                      one['hash'],
                      'wx_375_240',
                      // Number(one.height) > Number(one.width) ? 'wx_375_crop_vertical' : 'wx_375_crop',
                      {
                        width: Number(one.width),
                        height: Number(one.height),
                        targetWidth: 375,
                        watermark: watermarks,
                        watermark_fill:
                          currentPayWatermark && !currentIndexIsPayed
                            ? currentPayWatermark
                            : '',
                      },
                      one.id
                    )}
                    src={
                      one.loadStatus
                        ? imageUtil.style(
                          one['hash'],
                          'original',
                          {
                            width: Number(one.width),
                            height: Number(one.height),
                            targetWidth: Number(one.width),
                            watermark: watermarks,
                            watermark_fill:
                              currentPayWatermark && !currentIndexIsPayed
                                ? currentPayWatermark
                                : '',
                          },
                          one.id
                        )
                        : imageUtil.style(
                          one['hash'],
                          isWeb() ? 'wx_1920_n' : 'wx_750_n',
                          {
                            width: Number(one.width),
                            height: Number(one.height),
                            targetWidth: isWeb() ? 1920 : 1366,
                            watermark: watermarks,
                            watermark_fill:
                              currentPayWatermark && !currentIndexIsPayed
                                ? currentPayWatermark
                                : '',
                          },
                          one.id
                        )
                    }
                    mode={mode}
                  />
                );
              } else {
                return <div key={'empty' + index} />;
              }
            })}
          </SwipeableViews>
        ) : null}
      </div>
    );
  }
}
